import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "key"
const KeyIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.2 8.872C12.47 8.558 12.945 8.522 13.259 8.791 13.972 9.402 14.638 10.068 15.247 10.783 15.516 11.098 15.477 11.57 15.163 11.84 14.847 12.11 14.373 12.072 14.105 11.757Q13.265 10.772 12.283 9.93C11.968 9.66 11.932 9.187 12.2 8.872M14.076 5.746C14.33 5.418 14.8 5.356 15.127 5.609 16.361 6.559 17.467 7.665 18.415 8.899 18.668 9.227 18.605 9.698 18.278 9.95 17.949 10.203 17.478 10.142 17.226 9.813 16.356 8.683 15.343 7.668 14.213 6.797 13.885 6.545 13.823 6.074 14.076 5.746" />
          <path
            fillRule="evenodd"
            d="M12.355 3.069C13.153 1.984 14.635 1.519 15.902 2.212 16.902 2.76 18.224 3.604 19.35 4.73 20.474 5.854 21.31 7.168 21.853 8.163 22.543 9.427 22.076 10.903 20.996 11.698L15.748 15.556C14.724 16.31 13.36 16.324 12.33 15.651L6.746 21.165C6.232 21.673 5.538 21.958 4.815 21.96H2.057V19.216C2.057 18.481 2.35 17.776 2.875 17.26L8.435 11.77C7.735 10.736 7.738 9.348 8.5 8.309zM3.93 18.326C3.69 18.561 3.557 18.882 3.557 19.216V20.458H4.815C5.144 20.459 5.459 20.33 5.693 20.099L5.957 19.837C5.535 19.25 5.586 18.43 6.113 17.904L7.009 18.798 7.967 17.852C7.542 17.266 7.591 16.442 8.12 15.914L9.02 16.813 11.224 14.636 9.457 12.868zM15.18 3.528C14.657 3.24 13.975 3.398 13.564 3.957L9.71 9.199C9.328 9.719 9.327 10.416 9.68 10.933L13.126 14.38C13.643 14.732 14.339 14.73 14.859 14.348L20.107 10.49C20.665 10.08 20.82 9.401 20.537 8.881 20.03 7.955 19.273 6.775 18.288 5.791 17.3 4.802 16.113 4.038 15.18 3.527"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default KeyIcon
